import { Directive, inject, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[redispatchDisableControl]',
    standalone: false,
})
export class DisableControlDirective implements OnInit {

    private ngControl = inject(NgControl);
    private condition: boolean = false;

    @Input() set redispatchDisableControl(condition: boolean) {
        this.condition = condition;
        this.applyCondition();
    }

    ngOnInit() {
        this.applyCondition();
    }

    private applyCondition(): void {
        const action = this.condition ? 'disable' : 'enable';
        if (this.ngControl.control) {
            this.ngControl.control[action]();
        }
    }
}
